import React from 'react';
import { useParams } from 'react-router-dom';
import { EnhancedComparisonResults } from '../components/EnhancedComparisonResults';
import { ComparisonV2 } from '../components/ComparisonV2';
import { ResultsNewRoot } from '../components/results/ResultsNewRoot';
import { ResultsErrorBoundary } from '../components/results/shared/ErrorBoundary';
import { DebugLabel } from '../components/shared';
import { MainLayout } from '../layouts/MainLayout';
import { isFeatureEnabled } from '../utils/featureFlags';
import { useMetaTags } from '../hooks/useMetaTags';

export const ComparisonResultsPage: React.FC = () => {
  // Accept both UUID and slug formats (backend handles detection)
  const { idOrSlug: rawIdOrSlug } = useParams<{ idOrSlug: string }>();

  // Strip any hash fragments that might leak through
  const idOrSlug = rawIdOrSlug?.split('#')[0];

  // NEW_DESIGN_BETA graduated - features always enabled
  const betaEnabled = true;

  // Use idOrSlug as comparisonId - backend will resolve slugs to UUIDs
  const comparisonId = idOrSlug;

  // Set default meta tags for results page (will be overridden by ComparisonDetail)
  useMetaTags({
    // Mirror homepage SEO title until a specific comparison is selected
    // ComparisonDetail will override this when a detail view opens
    url: `${window.location.origin}/results${comparisonId ? `/${comparisonId}` : ''}`,
  });

  // Debug logging
  console.log('[ComparisonResultsPage] Rendered:', {
    rawIdOrSlug,
    cleanedIdOrSlug: idOrSlug,
    comparisonId,
    hash: window.location.hash,
    pathname: window.location.pathname,
    fullURL: window.location.href
  });

  return (
    <MainLayout>
      <DebugLabel label="ComparisonResultsPage-Container" type="page" position="top-left" />

      <div className="relative">
        <DebugLabel label="ComparisonResults-ConditionalRender" type="component" position="bottom-left" />
        <ResultsErrorBoundary>
          <ResultsNewRoot comparisonId={comparisonId || 'demo'} />
        </ResultsErrorBoundary>
      </div>
    </MainLayout>
  );
};